// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HomeListCard {
  display: flex;
  align-items: center;
  flex-direction: row;
}
@media screen and (max-width: 608px) {
  .HomeListCard {
    margin: 0 -2%;
  }
}
.HomeListCard__Content {
  display: flex;
  width: 100%;
}
.HomeListCard__Info {
  display: inline-flex;
}
.HomeListCard__Image {
  top: 0;
  margin-right: 2%;
  width: 30%;
  height: auto;
  max-width: 15rem;
}`, "",{"version":3,"sources":["webpack://./apps/app/src/app/views/home-list/home-list-card/home-list-card.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AACF;AACE;EALF;IAMI,aAAA;EAEF;AACF;AAAE;EACE,aAAA;EACA,WAAA;AAEJ;AAAE;EACE,oBAAA;AAEJ;AACE;EACE,MAAA;EACA,gBAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;AACJ","sourcesContent":[".HomeListCard {\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n\n  @media screen and (max-width: 608px) {\n    margin: 0 -2%; // matches home-list padding\n  }\n\n  &__Content {\n    display: flex;\n    width: 100%;\n  }\n  &__Info {\n    display: inline-flex;\n  }\n\n  &__Image {\n    top: 0;\n    margin-right: 2%;\n    width: 30%;\n    height: auto;\n    max-width: 15rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
